  <!-- blue button -->
  <aero-button [aeroStyle]="ButtonStyle.PRIMARY"
         [size]="ButtonSize.LARGE"
         label="Primary/Large Button">
  </aero-button>
  <br/><br/>
  <!-- red button -->
  <aero-button [aeroStyle]="ButtonStyle.ALERT"
         [size]="ButtonSize.LARGE"
         label="Alert/Large Button">
  </aero-button>
  <br/><br/>
  <!-- Secondary button -->
  <aero-button [aeroStyle]="ButtonStyle.SECONDARY"
         [size]="ButtonSize.LARGE"
         label="Secondary/Large Button">
  </aero-button>
  <br/><br/>

  <!-- Inactive button -->
  <aero-button label="Disabled Button"
         [disabled]="true">
  </aero-button>

  <br/><br/><br/>

  <!-- Slim buttons: -->
  <aero-button [aeroStyle]="ButtonStyle.PRIMARY"
         [size]="ButtonSize.SLIM"
         label="Create Page (Slim)">
  </aero-button>
  <br/><br/>
  <aero-button [aeroStyle]="ButtonStyle.PRIMARY"
         [size]="ButtonSize.SLIM"
         label="Create Collection (Slim)">
  </aero-button>
  <br/><br/>

  <aero-button [aeroStyle]="ButtonStyle.SECONDARY"
         icon="fal fa-image"
         [size]="ButtonSize.SLIM"
         label="Add Cover Image (Secondary/Slim/Icon)">
  </aero-button>

  <br/><br/><br/>

  <!-- Action button: -->
  <aero-button [aeroStyle]="ButtonStyle.ACTION"
         icon="fas fa-microphone"
         [size]="ButtonSize.SLIM"
         label="Record Audio (Action/Slim/Icon)">
  </aero-button>

  <br/><br/><br/>

  <!-- Default button -->
  <aero-button></aero-button>

  <br/><br/>

  <aero-button [aeroStyle]="ButtonStyle.ACTION"
         [size]="ButtonSize.LARGE">
  </aero-button>

  <br/><br/>

  <!-- Outline button -->
  <aero-button [aeroStyle]="ButtonStyle.OUTLINE"
         [icon]="'fas fa-users'"
         [size]="ButtonSize.LARGER"
         [label]="'Social Profiles'">
  </aero-button>
